/** @format */

import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Styles from "./Layouts.module.css";
import { BiMenu } from "react-icons/bi";
// import logo from "../assets/images/logo.png";

function Layout() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const Close = () => setClick(false);

  return (
    <div>
      <div className={click ? Styles.mainContainer : ""} onClick={() => Close()} />
      <nav className={Styles.navbar} onClick={(e) => e.stopPropagation()}>
        <div className={Styles.navContainer}>
          <NavLink
            // exact
            to="/"
            className={Styles.navLogo}
          >
            Prince Jha
          </NavLink>
          <div className={click ? `${Styles.navMenu} ${Styles.active}` : Styles.navMenu}>
            <span className={Styles.navItem}>
              <NavLink
                className={({ isActive }) => (isActive ? Styles.activelink : Styles.navlinks)}
                to="/"
                onClick={click ? handleClick : null}
              >
                Home
              </NavLink>
            </span>
            <span className={Styles.navItem}>
              <NavLink
                // exact
                to="about"
                className={({ isActive }) => (isActive ? Styles.activelink : Styles.navlinks)}
                onClick={click ? handleClick : null}
              >
                About
              </NavLink>
            </span>
            <span className={Styles.navItem}>
              <NavLink
                // exact
                to="services"
                className={({ isActive }) => (isActive ? Styles.activelink : Styles.navlinks)}
                onClick={click ? handleClick : null}
              >
                Services
              </NavLink>
            </span>
            <span className={Styles.navItem}>
              <NavLink
                // exact
                to="projects"
                className={({ isActive }) => (isActive ? Styles.activelink : Styles.navlinks)}
                onClick={click ? handleClick : null}
              >
                Projects
              </NavLink>
            </span>
            <span className={Styles.navItem}>
              <NavLink
                // exact
                to="contact"
                className={({ isActive }) => (isActive ? Styles.activelink : Styles.navlinks)}
                onClick={click ? handleClick : null}
              >
                Contacts
              </NavLink>
            </span>
          </div>
          <div className={Styles.navIcon} onClick={handleClick}>
            <BiMenu className={click ? "fa fa-times" : "fa fa-bars"} />
          </div>
        </div>
      </nav>
    </div>
  );
}

// const Layout = () => {
//   const [show, setShow] = useState(false);
//   const toggle = () => setShow(!show);

//   return (
//     <nav className={Styles.navbar}>
//       {/* <div className={Styles.logo}>
//         <img src={logo} alt="Prince Jha" />
//       </div> */}

//       <div className={Styles.bars}>
//         <BiMenu onClick={toggle} />
//       </div>
//       <div className={Styles.menu} style={{ left: !show ? "-100%" : "0" }}>
//         <NavLink
//           className={({ isActive }) => {
//             return isActive ? Styles.activeNavlinks : Styles.navlinks;
//           }}

//           to="/"
//           onClick={toggle}
//         >
//           Home
//         </NavLink>
//         <NavLink
//           className={({ isActive }) => {
//             return isActive ? Styles.activeNavlinks : Styles.navlinks;
//           }}
//           to="about"
//           onClick={toggle}
//         >
//           About
//         </NavLink>
//         <NavLink
//           className={({ isActive }) => {
//             return isActive ? Styles.activeNavlinks : Styles.navlinks;
//           }}
//           to="services"
//           onClick={toggle}
//         >
//           Services
//         </NavLink>
//         <NavLink
//           className={({ isActive }) => {
//             return isActive ? Styles.activeNavlinks : Styles.navlinks;
//           }}
//           to="resume"
//           onClick={toggle}
//         >
//           Resume
//         </NavLink>
//         <NavLink
//           className={({ isActive }) => {
//             return isActive ? Styles.activeNavlinks : Styles.navlinks;
//           }}
//           to="projects"
//           onClick={toggle}
//         >
//           Projects
//         </NavLink>
//         <NavLink
//           className={({ isActive }) => {
//             return isActive ? Styles.activeNavlinks : Styles.navlinks;
//           }}
//           to="contact"
//           onClick={toggle}
//         >
//           Contact
//         </NavLink>
//       </div>
//     </nav>
//   );
// };

export default Layout;
